import { render, staticRenderFns } from "./ruyiMachine.vue?vue&type=template&id=39718dae&scoped=true&"
import script from "./ruyiMachine.vue?vue&type=script&lang=js&"
export * from "./ruyiMachine.vue?vue&type=script&lang=js&"
import style0 from "./ruyiMachine.vue?vue&type=style&index=0&id=39718dae&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39718dae",
  null
  
)

export default component.exports